import { Form } from '@anytag/shared-atoms';
import { RejectedInfluencersTable, RejectedInfluencersTableProps } from './RejectedInfluencersTable';

export const RejectedInfluencers = (props: RejectedInfluencersTableProps) => (
  // We're using same hook for selected/rejected influencers table - which is using RHF, so put empty Provider to avoid some undefined context values
  <Form.Provider>
    <RejectedInfluencersTable {...props} />
  </Form.Provider>
);
